import { useRef } from 'react';
import { Volume2 } from 'lucide-react';
import { resolveMediaUrl } from '../../../utils/mediaUrl';
import { useTranslation } from '../../../i18n';

// Standalone short-clip element. Renders as a circular play button. Clicking
// during presentation/classroom plays the audio once from the start — no
// scrubber, no pause (that's what the `audio` element is for).
const SoundElement = ({ element, isEditor = false, interactive = false }) => {
  const { t } = useTranslation();
  const audioRef = useRef(null);
  const src = element?.content?.src;
  const resolved = src ? resolveMediaUrl(src) : '';

  const handleClick = (e) => {
    if (!interactive || !resolved) return;
    e.stopPropagation();
    e.preventDefault();
    if (!audioRef.current) {
      audioRef.current = new Audio(resolved);
    }
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(() => { /* user-gesture rejected — ignore */ });
  };

  const empty = !src;
  const baseClasses = 'w-full h-full rounded-full flex items-center justify-center shadow-md';
  const colorClasses = empty
    ? 'bg-gray-200 text-gray-400'
    : 'bg-gradient-to-br from-brand-primary to-brand-secondary text-white';
  const cursorClasses = interactive && !empty
    ? 'cursor-pointer hover:brightness-110 active:scale-95 transition pointer-events-auto'
    : isEditor
      ? 'cursor-default'
      : 'cursor-default pointer-events-none';

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseDown={(e) => interactive && !empty && e.stopPropagation()}
      title={empty ? t('games.common.noSound') : interactive ? t('games.common.playSound') : t('games.common.sound')}
      className={`${baseClasses} ${colorClasses} ${cursorClasses}`}
    >
      <Volume2 size={24} />
    </button>
  );
};

export default SoundElement;
